<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.valeur_stock' | trans" [accent]="valeurTotal()" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
    <vl-chips-toggle [elements]="groupByElements" [(value)]="groupBy" size="small"/>
  </vl-widget-title>

  @if (metadata().loading) {
    <div class="flex-row gap-16 widget-content">
      <div>
        <ngx-skeleton-loader count="1" appearance="circle" [theme]="{'height': '180px', 'width': '180px', 'background-color': 'var(--color-on-disabled)'}"/>
      </div>
      <div class="h100 w100 overflow-hidden">
        <ngx-skeleton-loader count="8" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
      </div>
    </div>
  } @else if (activeData()?.length) {
    <div class="flex-row w100 widget-content fade-in" style="overflow: hidden">
      <div class="h100 overflow-hidden grow" style="min-width: 0">
        <canvas #repart></canvas>
      </div>
      <div class="flex-col shrink-0 justify-between" style="max-width: 180px; overflow: hidden; padding-top: 8px">
        <div class="flex-col gap-2 mt-8">
          @if (labels()) {
            @for(label of labels(); track label.label) {
              <div class="flex-row gap-4 p-2 align-center">
                <span [style.background-color]="label.color" class="border-full shrink-0" style="width: 8px; height: 8px"></span>
                <span class="grow tiny on-background-alt" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{label.label}}</span>
                <span class="tiny on-disabled shrink-0">{{label.percentage}}%</span>
              </div>
            }
          }
        </div>
        <vl-chips state="active" size="small" iconRight="open_in_new" (action)="openFullList()">
          {{ 'button.see_all' | trans }}
        </vl-chips>
      </div>
    </div>
  } @else {
    <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
  }
</div>
